module.exports = __webpack_public_path__ + "img/3_Bericht_Beladen.65bab116.svg";